import "./index.scss";
import GridImg from "../../assets/images/bg-grid.png";
import LinesImg from "../../assets/images/bg-lines.png";
import TubesImg from "../../assets/images/bg-tubus.png";
import LogoImg from "../../assets/images/svg/logo-green.svg";
import TabletImg from "../../assets/images/pad.png";
import AppStoreImg from "../../assets/images/buttons/appstore.svg";
import PreorderImg from "../../assets/images/buttons/preorder.svg";

import React from "react";
import CustomButton from "../common/CustomButton";
import Pad from "./Pad";

const Gallery = ({ setOpenedModal }) => {
  return (
    <div className={`gallery`} id="gallery">
      <div className={`gallery__image-wrapper`}>
        <img
          src={GridImg}
          className={`gallery__image gallery__image--grid`}
          alt="grid"
        />
        <img
          src={LinesImg}
          className={`gallery__image gallery__image--lines`}
          alt="lines"
        />
        <img
          src={TubesImg}
          className={`gallery__image gallery__image--tubes`}
          alt="tubus"
        />
      </div>
      <div className={`gallery__content`}>
        <img src={LogoImg} className={`gallery__logo`} alt="logo" />
        <h2 className={`gallery__title`}>MA<span>/</span>Gallery</h2>
        <h3 className={`gallery__subtitle`}>
          First AI-powered art platform for inventory, contact and sales management
        </h3>
        <p className={`gallery__a1 gallery__text`}>
          MA Gallery is a break-through app for art professionals and collectors. 
          Built for iPad, this state-of-the-art tool combines next-generation 
          technology with a simple and intuitive interface. With its unique, 
          AI-powered features, MA Gallery allows you to efficiently manage your 
          inventory, communicate with clients and complete sales, from anywhere 
          in the world. 
        </p>
        <p className={`gallery__a2 gallery__text`}>
          Our innovative AI technology allows you to search your inventory for 
          artworks similar to a reference image by visual elements, colour scheme 
          or composition. Create Art Collections and showcase them to buyers with 
          our suite of sales and marketing tools:
        </p>
        <ul>
          <li>Private Viewing Rooms for individual clients,</li>
          <li>Online Exhibitions for global audiences,</li>
          <li>Presentations for face-to-face or virtual meetings.</li>
        </ul>
        <p className={`gallery__a3 gallery__text`}>
          Our CRM gives you a greater understanding of your clients than ever before. 
          The information you record about your clients’ preferences (favourite artists, 
          budget etc.) is enhanced by intelligence from our AI. The result is a 
          detailed digital portrait of each client. As your client interacts 
          with their Private Viewing Room, rating the artworks within it, our AI learns 
          about their preferences and can start making suggestions to you about what 
          artworks they might like.
        </p>
        <p className={`gallery__a4 gallery__text`}>
          All artworks and client data is stored in the cloud, and protected by a bank-level 
          security system. We use serverless architectures, sophisticated data encryption, 
          and we never store any passwords, so you can rest assured that all your data 
          is completely secure. 
        </p>
        <div className={`gallery__toolbar`}>
          <a
            href="https://apps.apple.com/us/app/ma-gallery-ai-powered-art-crm/id1599151137"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={AppStoreImg}
              alt="App Store"
              className={`gallery__toolbar-item`}
            />
          </a>
          <a
            href="https://www.apple.com/app-store/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={PreorderImg}
              alt="Pre-order"
              className={`gallery__toolbar-item`}
            />
          </a>
        </div>
        {/* <p className={`gallery__a5 gallery__smalltext`}>
          Besides the unprecedented CRM function and innovative AI data
          processing, MA Gallery will also feature a module for showcasing
          artworks from your inventory in virtual galleries.
        </p>
        <p className={`gallery__a6 gallery__smalltext`}>
          Advanced VR and AR technology will allow to create an immersive buying
          experience with virtual galleries and exhibitions. Being unconstrained
          by the dimensions of a real space, virtual galleries can be created
          from predesigned layouts and customised with different wall and floor
          furnishings.
        </p>
        <p className={`gallery__a7 gallery__smalltext`}>
          Art dealers can also use the handy VR/AR feature to scan their own
          gallery spaces with their personal device and recreate them in 3D in
          seconds. They can then choose their curatorial concept and arrange
          works from the gallery inventory on the virtual walls. A virtual
          gallery can be sent directly to buyers to be accessed via a web
          browser or on the MA Match app.
        </p>

        <CustomButton
          handleClick={setOpenedModal}
          animateButtonAndClass={"gallery__a8"}
          type={"gallery"}
        /> */}
      </div>
      <Pad />
      {/* <div className={`gallery__tablet-wrapper`}>
        <img src={TabletImg} className={`gallery__tablet`} alt="iPad" />
      </div> */}
    </div>
  );
};

export default Gallery;
